import React, { FC } from 'react';
import { IPhoneBlock } from '../../../models/forms';
import TextInput from '../../TextInput';

interface PhoneProps {
  field: IPhoneBlock,
  onChange: (value: IPhoneBlock) => void,
}

const Phone: FC<PhoneProps> = ({ field, onChange }) => (
  <>
    <TextInput
      value={field.label || ''}
      onChange={(e) => onChange({ ...field, label: e.target.value })}
    >
      Titel:
    </TextInput>
    <TextInput
      value={field.placeholder || ''}
      onChange={(e) => onChange({ ...field, placeholder: e.target.value })}
    >
      Platzhalter:
    </TextInput>
  </>
);

export default Phone;
